export const PageDataState = {
    Searchs: {
        name: {
            type: 'text',
            id: 'name',
            label: 'ศูนย์เครือข่าย',
            value: '',
            placeholder: 'ศูนย์เครือข่าย',
        },
        contact: {
            type: 'text',
            id: 'contact',
            label: 'เบอร์ติดต่อ',
            value: '',
            placeholder: 'เบอร์ติดต่อ',
        },
        email: {
            type: 'text',
            id: 'email',
            label: 'อีเมล',
            value: '',
            placeholder: 'อีเมล',
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            placeholder: 'สถานะ',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        name: {
            type: 'text',
            id: 'name',
            label: 'ศูนย์เครือข่าย',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        academy_id: {
            type: 'select',
            id: 'academy_id',
            label: 'สถานศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        logo: {
            type: 'file',
            id: 'logo',
            label: 'รูปภาพศูนย์เครือข่าย',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "image/png,image/jpeg",
            },
            error: { status: null, msg: '' }
        },
        background: {
            type: 'file',
            id: 'background',
            label: 'พื้นหลังโปรไฟล์',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "image/png,image/jpeg",
            },
            error: { status: null, msg: '' }
        },
        description: {
            type: 'textarea',
            rows: '5',
            id: 'description',
            label: 'รายละเอียดเกี่ยวกับศูนย์',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        }, 
        contact: {
            type: 'text',
            id: 'contact',
            label: 'เบอร์ติดต่อ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 9,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        email: {
            type: 'text',
            id: 'email',
            label: 'อีเมล',
            value: '',
            validator: {
                type: 'email',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },  
        location: {
            type: 'textarea',
            rows: '3',
            id: 'location',
            label: 'สถานที่ตั้ง',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },  
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }              
    },
    InputGroup: {}
}